<template>
  <div class="group_wrap">
    <BreadCrumb crumb="角色管理"></BreadCrumb>
    <div class="top_bar">
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入搜索内容: 角色" v-model="keyword" class="input-with-select" size="small">
            <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button>
          </el-input>
        </el-col>
       <AddGroup @fnResetTable="fnGetData"></AddGroup>
      </el-row>
    </div>
    <RoleTable :groups="aGroupList" @fnResetTable="fnGetData"></RoleTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddGroup from '@/components/widget/AddGroup'
import RoleTable from '@/components/widget/RoleTable'

import cons from '@/components/constant'

export default {
  name: 'Group',
  data () {
    return {
      keyword: '',
      page:1,
      pages:8,
      pagesize:10,
      aGroupList:[]
    }
  },
  components:{
    BreadCrumb,
    AddGroup,
    RoleTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/groups', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            order_by: 'id',
            keyword: this.keyword,
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          this.aGroupList = dat.data.data.groups;
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Role.vue